import {FormControl} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {useEffectPromise} from "../../../Hooks/EffectHooks";

export const ServiceDrivenDropDownFieldEditor = (Service) => {
	
	if(!Service) {
		debugger;
	}
	
	return (props) => {
	
		const {Value, OnUpdate, FieldDef, CustomData} = props;
		const {
			className = null,
			value = Value,
			onChange = OnUpdate,
			fieldDef = FieldDef,
			filter = (values) => values,
			customData = CustomData,
			additionalOptions = [],
			context = false
		} = props;
		
		const [models, setModels] = useState(null);
		
		const loadModels = async (context) => {
			try {
				return (await Service.GetWithContext(context))?.result ?? [];
			} catch (e) {
				console.log('loadModels failed for Service:', Service, e);
			}
			return null;
		}
		
		useEffectPromise(
			async () => loadModels(context),
			(result) => {
				setModels(result);
			},
			[JSON.stringify(context)],
			true
		);
		
		const modelOptions = models?.map(model => ({
			key: Service.GetPrimaryKey(model),
			value: Service.GetPrimaryKey(model),
			title: Service.GetTitle(model),
		})) ?? [];
	
		let options = [
			...additionalOptions,
			...modelOptions,
		];
	
		let defaultValue = null;
		if(options.find(m => String(m.value) === String(value)) === undefined && options?.[0]?.value != null) {
			// onChange(options[0]?.value);
			defaultValue = String(options[0]?.value);
		}
		
		const filteredOptions = filter([...options], defaultValue);
		
		useEffect(() => {
			if(defaultValue != null && value == null) {
				onChange(defaultValue);
			}
		}, [defaultValue]);
	
		return <FormControl
			as="select"
			className={className}
			placeholder={"Select A " + Service.ModelName}
			value={String(value ?? defaultValue)}
			onChange={x => onChange(x?.target?.value)}
		>
			{
				(models === null) &&
				<option key='0' value='0'>
					Loading...
				</option>
			}
			{
				filteredOptions?.map(option => {
					return <option key={option?.key ?? option?.value} value={option?.value}>
						{option?.title ?? option?.value}
					</option>;
				}) ?? null
			}
		</FormControl>;
	};
};

